export default __webpack_public_path__ + "static/media/bookRed.80b5f865.svg";